import { useEffect, useRef } from "react";
import Avatar from "../../../../../parts/avatar";
import { useRillContext } from "../../../../../rill/RillReact/share/base";
import { buildProgressPhotoPreviewHref } from "../../../../../utils/daily-stats";
import Photo from "./Photo";

const BodyPhotos = ({ photos, dailyStatId, utcDate }) => {
  const { locals } = useRillContext();
  const { activeUser, athlete, query } = locals;
  const { dailyStatId: queryDailyStatId, photoType: queryPhotoType } = query;
  return (
    <div>
      {["front", "back", "side"].map((type, index) => {
        return (
          <BodyPhoto
            key={`${dailyStatId}-${type}`}
            dailyStatId={dailyStatId}
            utcDate={utcDate}
            type={type}
            photos={photos}
            index={index}
            query={query}
            activeUser={activeUser}
            athlete={athlete}
            queryDailyStatId={queryDailyStatId}
            queryPhotoType={queryPhotoType}
          />
        );
      })}
    </div>
  );
};

const BodyPhoto = ({
  dailyStatId,
  type,
  index,
  photos,
  activeUser,
  athlete,
  queryDailyStatId,
  queryPhotoType,
  utcDate,
}) => {
  const photoLinkRef = useRef(null);
  const photo = photos?.[type];
  const photoThread = photo?.thread;
  const lastComment = photoThread?.lastComment;
  const lastCommentUser =
    lastComment?.sender ??
    [activeUser, athlete].find((user) => user?._id === lastComment?.senderId);

  // This is so that when redirecting from activity feed, we can open the preview photo modal
  useEffect(() => {
    if (photoLinkRef.current) {
      if (queryDailyStatId === dailyStatId && queryPhotoType === type) {
        photoLinkRef.current.click();
      }
    }
  }, [queryDailyStatId, queryPhotoType, dailyStatId, type]);

  const previewHref = buildProgressPhotoPreviewHref(
    type,
    photo?.s3Path,
    photoThread?._id,
    dailyStatId,
    utcDate
  );

  return (
    <div key={photos?.[type]?.name || index} className="progress-photo-wrapper">
      {lastComment?.message && (
        <div className="last-comment-wrapper">
          <Avatar user={lastCommentUser} size={28} />
          <div className="last-comment-message-wrapper">
            <span className="last-comment-message">{lastComment.message}</span>
            <div className="message-bubble-arrow" />
          </div>
        </div>
      )}
      <a ref={photoLinkRef} href={previewHref} className="progress-photo-link">
        <Photo
          src={photo?.s3Path ?? null}
          className="progress-photo"
          key={photos?.[type]?.name || index}
        />
      </a>
    </div>
  );
};

export default BodyPhotos;
